export { default } from './AsyncComponent';
